import { type IconProps } from '@frontend/legacy-components';
import { CaretDownIcon } from '@frontend/legacy-components/src/components/mediaAndIcons/icons/iconSet';

export interface TableV2ChildExpansionIconProps extends IconProps {
  isExpanded?: boolean;
}

export const TableV2ChildExpansionIcon = ({
  isExpanded,
  ...props
}: TableV2ChildExpansionIconProps) => {
  return (
    <CaretDownIcon
      transition="transform 0.25s"
      transform={isExpanded ? 'unset' : 'rotate(-90deg)'}
      {...props}
    />
  );
};
